import { Grid } from "@mui/material";
import React, { ChangeEvent, FC } from "react";
import { useSelector } from "react-redux";
import { AgencyCode, WspAgencyLabel } from "../../../../reducers/states/agency";
import { FeedStatusLevel } from "../../../../enums/feed-status";
import { IRootReducer } from "../../../../reducers";
import AgencyFilter from "./agency-filter";
import { useSearchParams } from "react-router-dom";

interface AgencyFiltersProps {
  props: {
    agencyFilters: string[];
    handleAgencySelect: (event: ChangeEvent<HTMLInputElement>) => void;
  };
}

const AgencyFilters: FC<AgencyFiltersProps> = ({ props }) => {
  const feedStatus = useSelector(
    (state: IRootReducer) => state.dispatchEventFeedReducer.feedStatus
  );
  
  const [searchParams] = useSearchParams();
  const isCheckFeedDisabled = searchParams.get('checkFeed') === "f";

  function isFeedDown(agency: string) {
    if(isCheckFeedDisabled) return false;
    
    let feed = feedStatus.find((f) => f.agency === agency);
    if (feed) {
      return feed.status !== FeedStatusLevel.OK;
    }

    // Default to not showing the indicator if we don't have the feed status retrieved
    return false;
  }

  const agencyFilters = [
    {
      agency: AgencyCode.KCM,
      tooltip: "Dispatch information for King County Metro",
    },
    {
      agency: AgencyCode.SFD,
      tooltip: "Dispatch information for Seattle Fire Department",
    },
    {
      agency: AgencyCode.SPD,
      tooltip: "Dispatch information for Seattle Police Department",
    },
    {
      agency: WspAgencyLabel.SEA,
      tooltip: "WSP dispatch information for King County. (WSP District 2)",
    },
    {
      agency: WspAgencyLabel.NW,
      tooltip: "WSP dispatch information for Snohomish, Skagit, Island, San Juan, and Whatcom counties. (WSP District 7)",
    },
    {
      agency: WspAgencyLabel.TAC,
      tooltip: "WSP dispatch information for Pierce and Thurston counties. (WSP District 1)",
    },
    {
      agency: WspAgencyLabel.SW,
      tooltip: "WSP dispatch information for Clark, Cowlitz, Lewis, Klickitat, and Skamania counties. (WSP District 5)",
    },
    {
      agency: WspAgencyLabel.PEN,
      tooltip: "WSP dispatch information for Clallam, Grays Harbor, Jefferson, Kitsap, Mason, Pacific and Wahkiakum Counties. (WSP District 8)",
    },
  ]

  return (
    <Grid container alignItems="center">
      {agencyFilters.map((filter, index) => {
        return (
          <Grid item key={index}>
            <AgencyFilter
              props={{
                agency: filter.agency,
                agencyFilters: props.agencyFilters,
                isFeedDown: isFeedDown(filter.agency.startsWith(AgencyCode.WSP) ? AgencyCode.WSP : filter.agency),
                tooltip: filter.tooltip,
                handleAgencySelect: props.handleAgencySelect,
              }}
            />
          </Grid>
        )
      })}
    </Grid>
  );
};

export default AgencyFilters;